import { render, staticRenderFns } from "./containers.vue?vue&type=template&id=31ac5ec0&"
import script from "./containers.vue?vue&type=script&lang=js&"
export * from "./containers.vue?vue&type=script&lang=js&"
import style0 from "./containers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports